import React from "react";
import { FaEye, FaRocket, FaLightbulb } from "react-icons/fa";
import "./AboutPage.css";

const AboutPage = () => {
  // Easter Egg: Click Vision, Mission, Innovation cards in order: Vision -> Innovation -> Mission
  const [clickSequence, setClickSequence] = React.useState([]);
  const [showCert, setShowCert] = React.useState(false);

  const handleCardClick = (cardName) => {
    setClickSequence(prev => {
      const next = [...prev, cardName];
      const trimmed = next.slice(-3);
      if (trimmed.join(',') === 'Vision,Innovation,Mission') {
        setShowCert(true);
        return [];
      }
      return trimmed;
    });
  };

  return (
    <div className="about-page">
      {/* ── Full-Width Cover Hero Banner ── */}
      <section className="about-hero" style={{ backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.2)), url("/about/about-us.png")' }}>
      </section>

      {/* ── Corporate Story & Narrative Content ── */}
      <section className="about-story-section">
        <div className="about-story-container">
          <div className="story-header">
            <span className="story-tagline">Our Story</span>
            <h2>A Legacy of Engineering Excellence</h2>
          </div>
          <div className="story-body">
            <div className="story-column">
              <p>
                iMatrix Technologies began its humble journey in 2006, with a clear vision to deliver innovative technical solutions and exceptional customer service. Over the years, we have developed fine-tuned, successful strategies for our vendors, leveraging solid expertise to push the boundaries of service delivery.
              </p>
              <p>
                In 2013, iMatrix Technologies was formally incorporated as <span className="highlight-text">iMatrix Technologies Private Limited</span>, further cementing our position in the industry. Our dedication to serving customers from all sectors is driven by our belief in the power of technology to improve lives.
              </p>
            </div>
            <div className="story-column">
              <p>
                At iMatrix Technologies, we synchronize our strengths to deliver exceptional results for our clients. Our unwavering commitment to continuous improvement ensures that we go beyond expectations, consistently upgrading our competencies to provide cutting-edge solutions.
              </p>
              <p>
                With over a decade of deep industry expertise, we build robust systems that enable digital transformation. Our core philosophy is built on client satisfaction, technical precision, and future-ready engineering structures.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── Vision & Mission Section ── */}
      <section className="vision-mission">
        <div
          className="card-about"
          onClick={() => handleCardClick('Vision')}
          style={{ cursor: 'pointer' }}
        >
          <div className="icon-box"><FaEye /></div>
          <h3>Our Vision</h3>
          <p>
            Our enduring mission is to create value by providing quality products that are delivered reliably and cost-effectively by our inspired optimistic work for our customers.
          </p>
        </div>

        <div
          className="card-about"
          onClick={() => handleCardClick('Mission')}
          style={{ cursor: 'pointer' }}
        >
          <div className="icon-box"><FaRocket /></div>
          <h3>Our Mission</h3>
          <p>
            To become the most preferred service provider in IT Sales, Service, and Training in India and abroad, running an ethical business that offers equality of opportunities.
          </p>
        </div>

        <div
          className="card-about"
          onClick={() => handleCardClick('Innovation')}
          style={{ cursor: 'pointer' }}
        >
          <div className="icon-box"><FaLightbulb /></div>
          <h3>Innovation</h3>
          <p>
            To foster innovation and creativity, ensuring that our services adapt to the evolving needs of our clients while contributing positively to the communities we serve.
          </p>
        </div>
      </section>

      {/* Easter Egg: Quality Certification Modal */}
      {showCert && (
        <div
          className="secret-cert-overlay"
          onClick={() => setShowCert(false)}
          style={{
            position: 'fixed', inset: 0, zIndex: 999990,
            background: 'rgba(10, 15, 30, 0.7)', backdropFilter: 'blur(8px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px'
          }}
        >
          <div
            className="secret-cert-card"
            onClick={e => e.stopPropagation()}
            style={{
              background: '#0d1627',
              border: '2px solid #a3ba84',
              borderRadius: '24px',
              padding: '40px',
              maxWidth: '540px',
              width: '100%',
              textAlign: 'center',
              boxShadow: '0 30px 80px rgba(0,0,0,0.6), 0 0 40px rgba(141, 164, 110, 0.2)',
              position: 'relative',
              animation: 'ctx-menu-in 0.4s cubic-bezier(0.16,1,0.3,1) forwards',
              color: '#f0f6fc',
              fontFamily: "'Courier New', Courier, monospace"
            }}
          >
            {/* Hologram badge */}
            <div style={{
              width: 72, height: 72, borderRadius: '50%',
              background: 'radial-gradient(circle, #a3ba84, #4a5c35)',
              margin: '0 auto 20px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '2rem', boxShadow: '0 0 20px rgba(163, 186, 132, 0.5)'
            }}>🛡️</div>

            <h3 style={{ color: '#a3ba84', fontSize: '1.35rem', fontWeight: 'bold', margin: '0 0 10px 0', letterSpacing: '0.05em' }}>
              iMatrix Innovation Certification
            </h3>
            <p style={{ fontSize: '0.82rem', color: '#94a3b8', margin: '0 0 24px 0', textTransform: 'uppercase', letterSpacing: '0.12em' }}>
              Vision &bull; Innovation &bull; Mission Realized
            </p>
            <div style={{
              borderTop: '1px solid rgba(255,255,255,0.08)',
              borderBottom: '1px solid rgba(255,255,255,0.08)',
              padding: '20px 0',
              margin: '0 0 24px 0',
              textAlign: 'left',
              fontSize: '0.85rem',
              lineHeight: 1.6,
              color: '#cbd5e1'
            }}>
              <div>[SYSTEM VERIFICATION STATUS]</div>
              <div style={{ marginTop: 8 }}>&bull; Corporate Vision Mapping: Synchronized</div>
              <div>&bull; Operational Innovation Focus: Synchronized</div>
              <div>&bull; Ethical Mission Alignment: Synchronized</div>
              <div style={{ marginTop: 12, fontSize: '0.78rem', color: '#64748b' }}>
                Integrity reference: IMT-VIM-2006-OK
              </div>
            </div>
            <p style={{ fontSize: '0.85rem', color: '#64748b', fontStyle: 'italic', marginBottom: 20 }}>
              “Building future-ready technology networks since 2006.”
            </p>
            <button
              onClick={() => setShowCert(false)}
              style={{
                background: '#a3ba84', border: 'none', borderRadius: '8px',
                padding: '10px 24px', cursor: 'pointer', color: '#0d1627',
                fontWeight: 'bold', fontSize: '0.9rem', transition: 'background 0.2s'
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#8da46e'}
              onMouseLeave={e => e.currentTarget.style.background = '#a3ba84'}
            >
              System Sync Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AboutPage;
